<template>
  <v-dialog v-model="dialog" max-width="290">
    <v-card>
      <v-card-text :class="$style.message">
        <span v-html="httpStatusMessage"></span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" flat="flat" @click="dialog = false">
          {{ lang.close }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
  name: "vc-share-error-dialog",
  props: {
    error: {
      // type: Object,
      default: () => {
        return {
          data: {}
        };
      }
    },
    resetError: {
      type: Function,
      default: () => {}
    },
    lang: {
      type: Object,
      default: () => {
        return {
          error: "エラー",
          close: "閉じる",
          http_status_message: []
        };
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return (
          _.size(this.$props.error) > 0 || this.$props.error instanceof Error
        );
      },
      set(value) {
        if (!value) {
          this.$props.resetError({});
        }
      }
    },
    httpStatusMessage() {
      // JS のエラーオブジェクトではない、エラーオブジェクトの中身があればデフォルトエラーメッセージを表示する
      if (
        _.size(this.$props.error) === 0 &&
        this.$props.error instanceof Error === false
      ) {
        return "";
      }

      // http status が 200, APIエラーの場合は レスポンスのメッセージを表示する

      // FIXME: errorMessage を配列にする。

      if (this.error.status === -1) {
        if (this.error.code === "invalid_parameter") {
          let tmpObject = Object.values(this.error.data);
          let errorMessage = [];

          for (let arr in tmpObject) {
            errorMessage += tmpObject[arr] + "<br>";
          }
          return errorMessage;
        }

        return this.error.data.error_message;
      }

      // http status が 200 以外の時は、http status に応じたメッセージを表示する
      if (this.lang.http_status_message[this.error.status]) {
        return this.lang.http_status_message[this.error.status];
      } else {
        // 該当するエラーがなければ
        return this.lang.http_status_message.default;
      }
    }
  }
};
</script>
<style module>
.message {
  white-space: pre-line;
}
</style>
